export default __webpack_public_path__ + "static/media/Backspace_Noon.a517e053.png";